/* eslint-disable eqeqeq */
import { store } from '../store';

export default function formatDispositionNumToString(dispositionNum) {
  const currentState = store.getState();
  const leadStatusOptions = currentState.leadStatus.options || [];

  const dispositionObject = leadStatusOptions.find((status) => status.value == dispositionNum);
  return dispositionObject ? dispositionObject.description : 'Invalid Status Number';
}
